import { styled } from "styled-components";

export const MyNickName = styled.div`
  font-size: 24px;
`;
